module.exports = __webpack_public_path__ + "img/rights.ec97993.webp";